import { FC, useEffect, useState } from 'react'
import {
  OrangeButton
} from '../index'
import {
  Container,
  CheckboxLabel,
  ExistingContactTable
} from './styles'
import Button from 'src/components/basic/Button'
import { TbMailForward } from 'react-icons/tb'
import StandardCheckbox from 'src/components/basic/StandardCheckbox'
import { ISIExistingContactData, NoExistingContactSelection, NewContactSelection } from 'src/dtos/portal'
import { ascendingSorter } from 'src/utils/array'



interface ExistingContactSelectProps {
  removeNoClick : boolean;
  onCancel: () => void;
  selectionList: ISIExistingContactData[];
  submitApplication: (selection: ISIExistingContactData) => Promise<void>
}

const ExistingContactSelect: FC<ExistingContactSelectProps> = ({ removeNoClick ,onCancel, selectionList, submitApplication }) => {
  const [selected, setSelected] = useState<ISIExistingContactData>(NoExistingContactSelection);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true)

  const [sortedSelections, setSortedSelections] = useState<ISIExistingContactData[]>([]);
  

  useEffect(() => {
    const mainPortal = document.getElementById('admin-main-portal-container')

    if(removeNoClick) {
      mainPortal?.classList.remove('no-click')
    }
  }, [removeNoClick])
    
  useEffect(() => {
    setSortedSelections(selectionList.sort(ascendingSorter( (o:ISIExistingContactData)  => o.searchMethod))); //cause "BarCardNumber" suggestions to show above "ClientName" suggestions
  },[selectionList])



  const selectOption = (option: ISIExistingContactData) => {
    setSelected(option)
    setSubmitButtonDisabled(!option)
  }

  const handleSubmitApplication = async () => {
    setSubmitButtonDisabled(true)
    await submitApplication(selected)
    setSubmitButtonDisabled(false)
  }




  return (
    <Container>
      <div className='select-existing-contact-container'>
        <header>
          Existing contacts were found. How would you like to continue?
        </header>
        <main>
          <article>
            <StandardCheckbox
              label={<CheckboxLabel>Create a new contact.</CheckboxLabel>}
              onChange={() => selectOption(NewContactSelection)}
              checked={selected === NewContactSelection}
            />
          </article>
          <article>
            <section>
              Add this application to an existing contact (select below).
            </section>
            {sortedSelections.length ? (
              <>
                <section>
                  <ExistingContactTable>
                    <thead>
                      <tr>
                        <th></th>
                        <th className="contact-key">Contact Key</th>
                        <th className="name-email">Name / Email</th>
                      </tr>
                    </thead>
                    <tbody>
                    { sortedSelections.map(item => (
                      <tr key={`via-bar-card-number-${item.contactKey}`}>
                        <td>
                          <StandardCheckbox
                              onChange={() => selectOption(item)}
                              checked={selected === item}
                            />
                        </td>  
                        <td className="contact-key">{item.contactKey}</td>
                        <td>{item.name}<br/>{item.email}</td>

                      </tr>                
                    ))}              
                    </tbody>
                </ExistingContactTable>
              </section>
            </>
            ) : null} 
          </article>
          <footer>
            <OrangeButton onClick={handleSubmitApplication} disabled={submitButtonDisabled} wide>
              <TbMailForward/>
              Submit Application
            </OrangeButton>
            <Button
              variant='secondary'
              padding="5.5px 12px"
              minWidth='68px'
              onClick={onCancel}
            >
              Cancel
            </Button>
          </footer>
        </main>
      </div>
    </Container>
  )
}

export default ExistingContactSelect